import { Box, Skeleton } from '@mui/material';
import {
	productImageFrameSX,
	productInfoSX,
	productRowSX,
} from '@/components/blocks/EmailRecommendedCouponPopup/styles';

export const ProductItemSkeleton = () => (
	<Box sx={productRowSX}>
		<Skeleton variant="rectangular" width={20} height={20} sx={{ borderRadius: '4px' }} />
		<Box sx={productImageFrameSX}>
			<Skeleton variant="rectangular" width="100%" height="100%" />
		</Box>
		<Box sx={productInfoSX}>
			<Skeleton variant="text" width="70%" height={18} />
			<Skeleton variant="text" width="40%" height={18} />
			<Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: '4px' }} />
		</Box>
	</Box>
);
